// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InlineEdit_label__PShOX {
    line-height: 25px;
}

.InlineEdit_label__PShOX.InlineEdit_sizeSM__XbI6Y {
    font-size: 14px;
}

.InlineEdit_label__PShOX.InlineEdit_sizeMD__jWjR0 {
    font-size: 16px;
}

.InlineEdit_label__PShOX.InlineEdit_sizeLG__KLOyE {
    font-size: 18px;
}

.InlineEdit_label__PShOX.InlineEdit_sizeXL__5nvg\\+ {
    font-size: 20px;
}

.InlineEdit_editField__oT7wB[type="text"] {
    border: 1px solid var(--color-201);
    font-size: 18px;
    font-weight: 300;
    line-height: 25px;
    height: 25px;
    padding: 0;
    margin-top: -2px;
    background-color: var(--color-106);
    display: inline-block;
    border-radius: 2px;
    box-shadow: none;
    width: 60px;
}

.InlineEdit_editField__oT7wB.InlineEdit_inputXS__-3s41 {
    width: 30px;
}

.InlineEdit_editField__oT7wB.InlineEdit_inputSM__9c6nC {
    width: 60px;
}

.InlineEdit_editField__oT7wB.InlineEdit_inputMD__2A14s {
    width: 90px;
}

.InlineEdit_editField__oT7wB.InlineEdit_inputLG__5YXiJ {
    width: 150px;
}

.InlineEdit_editField__oT7wB.InlineEdit_inputXL__hLL\\+6 {
    width: 210px;
}

.InlineEdit_editIcon__7vqhd {
    margin: 2px 5px 0px 5px;
    font-size: 14px;
    color: var(--color-icon-secondary);
    display: inline-block;
    vertical-align: middle;
}

.InlineEdit_editIcon__7vqhd:hover {
    color: var(--color-icon-secondary-hover);
}


.InlineEdit_saveIcon__\\+WjjM,
.InlineEdit_closeIcon__Vgibe {
    width: 22px;
    height: 22px;
    border-radius: 50px;
    margin-left: 3px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
}

.InlineEdit_saveIcon__\\+WjjM {
    font-size: 14px;
    color: var(--color-401);
    background: var(--color-404);
}

.InlineEdit_saveIcon__\\+WjjM:hover {
    background: var(--color-405);
}

.InlineEdit_closeIcon__Vgibe {
    font-size: 10px;
    color: var(--color-icon-secondary);
    background: var(--color-116);
}

.InlineEdit_closeIcon__Vgibe:hover {
    background: var(--color-127);
}

.InlineEdit_editContainer__0iIxi {
    position: relative;
    display: inline-block;
}

.InlineEdit_dropdown__W4PwH {
    position: absolute;
    left: 0;
    background: var(--color-106);
    border: 1px solid var(--color-103);
    border-radius: 4px;
    min-width: 100px;
    max-height: 300px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    z-index: 10;
}

.InlineEdit_editField__oT7wB.InlineEdit_fitContent__BTgAi {
    width: 100%;
}

.InlineEdit_fitContentContainer__ryGDK {
    max-width: 100%;
}

.InlineEdit_fitContentContainer__ryGDK > div {
   max-width: calc(100% - 50px);
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/InlineEdit/InlineEdit.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,kCAAkC;IAClC,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;AAC5C;;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,4BAA4B;IAC5B,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;GACG,4BAA4B;AAC/B","sourcesContent":[".label {\n    line-height: 25px;\n}\n\n.label.sizeSM {\n    font-size: 14px;\n}\n\n.label.sizeMD {\n    font-size: 16px;\n}\n\n.label.sizeLG {\n    font-size: 18px;\n}\n\n.label.sizeXL {\n    font-size: 20px;\n}\n\n.editField[type=\"text\"] {\n    border: 1px solid var(--color-201);\n    font-size: 18px;\n    font-weight: 300;\n    line-height: 25px;\n    height: 25px;\n    padding: 0;\n    margin-top: -2px;\n    background-color: var(--color-106);\n    display: inline-block;\n    border-radius: 2px;\n    box-shadow: none;\n    width: 60px;\n}\n\n.editField.inputXS {\n    width: 30px;\n}\n\n.editField.inputSM {\n    width: 60px;\n}\n\n.editField.inputMD {\n    width: 90px;\n}\n\n.editField.inputLG {\n    width: 150px;\n}\n\n.editField.inputXL {\n    width: 210px;\n}\n\n.editIcon {\n    margin: 2px 5px 0px 5px;\n    font-size: 14px;\n    color: var(--color-icon-secondary);\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.editIcon:hover {\n    color: var(--color-icon-secondary-hover);\n}\n\n\n.saveIcon,\n.closeIcon {\n    width: 22px;\n    height: 22px;\n    border-radius: 50px;\n    margin-left: 3px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n}\n\n.saveIcon {\n    font-size: 14px;\n    color: var(--color-401);\n    background: var(--color-404);\n}\n\n.saveIcon:hover {\n    background: var(--color-405);\n}\n\n.closeIcon {\n    font-size: 10px;\n    color: var(--color-icon-secondary);\n    background: var(--color-116);\n}\n\n.closeIcon:hover {\n    background: var(--color-127);\n}\n\n.editContainer {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdown {\n    position: absolute;\n    left: 0;\n    background: var(--color-106);\n    border: 1px solid var(--color-103);\n    border-radius: 4px;\n    min-width: 100px;\n    max-height: 300px;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    z-index: 10;\n}\n\n.editField.fitContent {\n    width: 100%;\n}\n\n.fitContentContainer {\n    max-width: 100%;\n}\n\n.fitContentContainer > div {\n   max-width: calc(100% - 50px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `InlineEdit_label__PShOX`,
	"sizeSM": `InlineEdit_sizeSM__XbI6Y`,
	"sizeMD": `InlineEdit_sizeMD__jWjR0`,
	"sizeLG": `InlineEdit_sizeLG__KLOyE`,
	"sizeXL": `InlineEdit_sizeXL__5nvg+`,
	"editField": `InlineEdit_editField__oT7wB`,
	"inputXS": `InlineEdit_inputXS__-3s41`,
	"inputSM": `InlineEdit_inputSM__9c6nC`,
	"inputMD": `InlineEdit_inputMD__2A14s`,
	"inputLG": `InlineEdit_inputLG__5YXiJ`,
	"inputXL": `InlineEdit_inputXL__hLL+6`,
	"editIcon": `InlineEdit_editIcon__7vqhd`,
	"saveIcon": `InlineEdit_saveIcon__+WjjM`,
	"closeIcon": `InlineEdit_closeIcon__Vgibe`,
	"editContainer": `InlineEdit_editContainer__0iIxi`,
	"dropdown": `InlineEdit_dropdown__W4PwH`,
	"fitContent": `InlineEdit_fitContent__BTgAi`,
	"fitContentContainer": `InlineEdit_fitContentContainer__ryGDK`
};
export default ___CSS_LOADER_EXPORT___;
